import { Component, inject, OnInit } from '@angular/core';
import { MemberNetworkQuery, MemberNetworkService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-member-network-page',
  templateUrl: './member-network-page.component.html',
  styleUrl: './member-network-page.component.scss'
})
export class MemberNetworkPageComponent implements OnInit {
  private memberNetworkService = inject(MemberNetworkService);
  private memberNetworkQuery = inject(MemberNetworkQuery);
  networkMembers$ = this.memberNetworkQuery.selectAll();

  ngOnInit(): void {
    firstValueFrom(this.memberNetworkService.fatchNetworkMembers());
  }
}
